/* js/components/socialShare/WhatsApp.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	append,
	assign,
	attr,
	compute_rest_props,
	create_component,
	destroy_component,
	detach,
	exclude_internal_props,
	get_spread_object,
	get_spread_update,
	init,
	insert,
	mount_component,
	safe_not_equal,
	svg_element,
	transition_in,
	transition_out
} from "svelte/internal";

import ShareButton from './ShareButton.svelte';

function create_default_slot(ctx) {
	let svg;
	let path;

	return {
		c() {
			svg = svg_element("svg");
			path = svg_element("path");
			attr(path, "d", "M20.1 3.9C17.9 1.7 15 .5 12 .5 5.8.5.7 5.6.7 11.9c0 2 .5 3.9 1.5 5.6L.6 23.4l6-1.6c1.6.9 3.5 1.3 5.4 1.3 6.3 0 11.4-5.1 11.4-11.4-.1-2.8-1.2-5.7-3.3-7.8zM12 21.4c-1.7 0-3.3-.5-4.8-1.3l-.4-.2-3.5 1 1-3.4L4 17c-1-1.5-1.4-3.2-1.4-5.1 0-5.2 4.2-9.4 9.4-9.4 2.5 0 4.9 1 6.7 2.8 1.8 1.8 2.8 4.2 2.8 6.7-.1 5.2-4.3 9.4-9.5 9.4zm5.1-7.1c-.3-.1-1.7-.9-1.9-1-.3-.1-.5-.1-.7.1-.2.3-.8 1-.9 1.1-.2.2-.3.2-.6.1s-1.2-.5-2.3-1.4c-.9-.8-1.4-1.7-1.6-2-.2-.3 0-.5.1-.6s.3-.3.4-.5c.2-.1.3-.3.4-.5.1-.2 0-.4 0-.5C10 9 9.3 7.6 9 7c-.1-.4-.4-.3-.5-.3h-.6s-.4.1-.7.3c-.3.3-1 1-1 2.4s1 2.8 1.1 3c.1.2 2 3.1 4.9 4.3.7.3 1.2.5 1.6.6.7.2 1.3.2 1.8.1.6-.1 1.7-.7 1.9-1.3.2-.7.2-1.2.2-1.3-.1-.3-.3-.4-.6-.5z");
			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
			attr(svg, "viewBox", "0 0 24 24");
		},
		m(target, anchor) {
			insert(target, svg, anchor);
			append(svg, path);
		},
		d(detaching) {
			if (detaching) detach(svg);
		}
	};
}

function create_fragment(ctx) {
	let sharebutton;
	let current;

	const sharebutton_spread_levels = [
		{
			class: "ssbc-button--whatsapp " + /*classes*/ ctx[1]
		},
		/*$$restProps*/ ctx[3],
		{ ariaLabel: /*ariaLabel*/ ctx[0] },
		{ href: /*href*/ ctx[2] }
	];

	let sharebutton_props = {
		$$slots: { default: [create_default_slot] },
		$$scope: { ctx }
	};

	for (let i = 0; i < sharebutton_spread_levels.length; i += 1) {
		sharebutton_props = assign(sharebutton_props, sharebutton_spread_levels[i]);
	}

	sharebutton = new ShareButton({ props: sharebutton_props });

	return {
		c() {
			create_component(sharebutton.$$.fragment);
		},
		m(target, anchor) {
			mount_component(sharebutton, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const sharebutton_changes = (dirty & /*classes, $$restProps, ariaLabel, href*/ 15)
			? get_spread_update(sharebutton_spread_levels, [
					dirty & /*classes*/ 2 && {
						class: "ssbc-button--whatsapp " + /*classes*/ ctx[1]
					},
					dirty & /*$$restProps*/ 8 && get_spread_object(/*$$restProps*/ ctx[3]),
					dirty & /*ariaLabel*/ 1 && { ariaLabel: /*ariaLabel*/ ctx[0] },
					dirty & /*href*/ 4 && { href: /*href*/ ctx[2] }
				])
			: {};

			if (dirty & /*$$scope*/ 32) {
				sharebutton_changes.$$scope = { dirty, ctx };
			}

			sharebutton.$set(sharebutton_changes);
		},
		i(local) {
			if (current) return;
			transition_in(sharebutton.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(sharebutton.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(sharebutton, detaching);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	const omit_props_names = ["text","ariaLabel","class"];
	let $$restProps = compute_rest_props($$props, omit_props_names);
	let { text } = $$props;
	let { ariaLabel = 'Share on WhatsApp' } = $$props;
	let { class: classes = '' } = $$props;
	let href;

	$$self.$$set = $$new_props => {
		$$props = assign(assign({}, $$props), exclude_internal_props($$new_props));
		$$invalidate(3, $$restProps = compute_rest_props($$props, omit_props_names));
		if ('text' in $$new_props) $$invalidate(4, text = $$new_props.text);
		if ('ariaLabel' in $$new_props) $$invalidate(0, ariaLabel = $$new_props.ariaLabel);
		if ('class' in $$new_props) $$invalidate(1, classes = $$new_props.class);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*text*/ 16) {
			$: $$invalidate(2, href = encodeURI(`whatsapp://send?text=${text}`));
		}
	};

	return [ariaLabel, classes, href, $$restProps, text];
}

class WhatsApp extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { text: 4, ariaLabel: 0, class: 1 });
	}
}

export default WhatsApp;